$(document).ready(function () {
    const IDENTIFIER = "customer_sales_report";
    const searchResultTableSelector = 'div#' + IDENTIFIER + '_wrapper div#' + IDENTIFIER + '_customer_search_result_wrapper table tbody';
    const wrapper = $('div#' + IDENTIFIER + "_wrapper");
    const pathCustomerSearch = "/action/customer/get-collenction";
    const pathReport = "/action/report/customer-sales";
    const pathExcelExportURL = "/action/report/excel/customer-sales-report";
    const fetchReportButton = $("div#fetch_" + IDENTIFIER + "_button");
    const dateFromInput = $("input#" + IDENTIFIER + "_date_from");
    const dateToInput = $("input#" + IDENTIFIER + "_date_to");
    const storeSelect = $("select#" + IDENTIFIER + "_store_select");
    const customerGroupSelect = $("select#" + IDENTIFIER + "_customer_group_select");
    const reportTypeSelect = $("select#" + IDENTIFIER + "_report_type_select");
    const includeProductsCheckbox = $("input[name='" + IDENTIFIER + "_include_product_details']");
    const customerGroupSelectWrapper = $("div#" + IDENTIFIER + "_customer_group_select_wrapper");
    const customerSearchWrapper = $("div#" + IDENTIFIER + "_customer_search_wrapper");
    const customerSearchResultWrapper = $("div#" + IDENTIFIER + "_customer_search_result_wrapper");
    const reportDataWrapper = $("div#" + IDENTIFIER + "_data_wrapper");
    const chosenCustomerWrapper = $('div#' + IDENTIFIER + '_chosen_customer_wrapper');
    const chosenCustomerDiv = $('div#' + IDENTIFIER + '_chosen_customer');

    const searchKeyupDelay = 300;

    let ajaxLockActive = false;

    initReportDatePickers();

    fetchReportButton.click(function (e) {
        if (ajaxLockActive){
            return false;
        }

        ajaxLockActive = true;

        displayLoadingGifInButton()
        const data = getDataParameters();
        $.ajax({
            type: 'GET',
            url: pathReport,
            data: data,
            dataType: 'json'
        }).success(function (data) {
            reportDataWrapper.html(data.report);
        }).error(function (data) {
            let modalTitle = 'Det oppstod en feil!';
            let modalMessage = $.parseJSON(data.responseText).errors;
            let modalAlertType = 'error';

            displayInfoMessageModal(wrapper, modalTitle, modalMessage, 'Lukk', modalAlertType);
        }).always(function() {
            removeLoadingGifFromButton();
            ajaxLockActive = false;
        });
    });

    $(document).on('click', 'div#' + IDENTIFIER + '_data_wrapper a#customer_sales_download_excel_report_button', function () {
        createExcelFile();
        return false;
    });

    reportTypeSelect.change(function() {
        if ($(this).val() === 'customer_group') {
            customerGroupSelectWrapper.show();
            customerSearchWrapper.hide();
            customerSearchResultWrapper.hide();
            chosenCustomerWrapper.hide();
        } else {
            customerGroupSelectWrapper.hide();
            customerSearchWrapper.show();
            chosenCustomerWrapper.show();
            // customerSearchResultWrapper.show();
        }
    });

    /**
     * Keyup in customer search, delay search until no more keyups for 500ms
     */
    $(wrapper).on('keyup', 'div#' + IDENTIFIER + '_wrapper input[name="customer_sales_report_customer_search_input"]', delay(function (e) {
        customerSearch(this.value, e);
    }, searchKeyupDelay));

    // Select customer
    $(wrapper).on('click', searchResultTableSelector + ' td', function () {
        let tr = $(this).closest('tr');
        selectCustomer(tr.attr('customer_id'), tr.attr('name'), tr.attr('customer_number'));
    });

    // Remove selected customer, and display customer search again
    $(wrapper).on('click', 'div#' + IDENTIFIER + '_wrapper button[data-customer-sales-report-remove="1"]', function () {
        removeSelectedCustomer();
    });

    $(document).on('click', 'div#' + IDENTIFIER + '_data_wrapper tr.customer_row td', function () {
        // Toggle this customer product details
        let customerId = $(this).closest('tr').attr('customer_id');
        $('tr[parent_customer_id="' + customerId + '"]').each(function() {
            $(this).toggle();
        });
    });

    function customerSearch(searchString, event) {
        if ($.trim(searchString) === '' || $.trim(searchString).length < 2) {
            customerSearchResultWrapper.hide();
            return;
        }

        if (event.key === "Backspace") {
            return;
        }

        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }
        ajaxLockActive = true;

        //Post serialized form and save PriceLevel
        $.ajax({
            type: 'GET',
            url: pathCustomerSearch,
            data: {
                search_string: searchString
            },
            dataType: 'json',
        }).success(function (json) {
            // Remove existing search results
            $(searchResultTableSelector).html('');
            if (customerSearchResultWrapper.is(':hidden')) {
                customerSearchResultWrapper.show();
            }

            let customers = JSON.parse(json.customers);
            for (let key in customers) {
                let customer = customers[key];
                console.log(customer.name);

                let tr = '<tr class="cursor-pointer transition hover:bg-slate-50" customer_id="' + customer.customer_id + '" name="' + customer.name + '" customer_number="' + customer.customer_number + '"><td class="px-4 py-3 text-sm text-slate-700">' + customer.name + '</td><td class="px-4 py-3 text-sm text-slate-700">' + customer.customer_number + '</td></tr>';
                // Add row to search result table
                $(searchResultTableSelector).append(tr);
            }
            // $('div#step_discount_product_search_results tbody').html(data.search_result_html);
        }).error(function () {
            displayAlertMessage('Det oppstod en feil!', 'Kunne ikke søke på product, vennligst last siden på nytt', 'danger', wrapper);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function selectCustomer(customerId, name, customerNumber) {
        customerSearchWrapper.hide();
        customerSearchResultWrapper.hide();

        chosenCustomerDiv.html('<div class="mb-3 text-sm text-slate-700" role="alert">\n' +
            '  <button type="button" class="mr-2 inline-flex h-8 w-8 items-center justify-center rounded-md border border-danger bg-danger text-xl leading-none text-white shadow-sm transition duration-200 hover:bg-danger/90 hover:border-danger/90 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none" data-customer-sales-report-remove="1" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n' +
            '  <input type="hidden" name="customer_id" value="' + customerId + '">\n' +
            name + ' (' + customerNumber + ') \n' +
            '</div>');
        chosenCustomerWrapper.show();
    }

    function removeSelectedCustomer() {
        customerSearchWrapper.show();
        customerSearchResultWrapper.hide();

        chosenCustomerDiv.html('');
        chosenCustomerWrapper.hide();
    }

    function createExcelFile() {
        if (ajaxLockActive) {
            return;
        }
        ajaxLockActive = true;

        $.ajax({
            type: 'GET',
            url: pathExcelExportURL,
            data: getDataParameters(),
            dataType: 'json'
        }).success(function (data) {
            window.location = '/includes/report/excels/' + data.excel_file_name;
        }).error(function (data) {
            let modalTitle = 'Det oppstod en feil!';
            let modalMessage = $.parseJSON(data.responseText).errors;
            let modalAlertType = 'error';

            displayInfoMessageModal(wrapper, modalTitle, modalMessage, 'Lukk', modalAlertType);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    /**
     * Returns parameters sent to controller
     *
     * @returns
     */
    function getDataParameters() {
        let data = {
            from_date: dateFromInput.val(),
            to_date: dateToInput.val(),
        };

        console.log('---');
        if (reportTypeSelect.val() === 'customer_group') {
            data.customer_group_id = customerGroupSelect.val();
        } else {
            data.customer_id = $('div#' + IDENTIFIER + '_wrapper input[name="customer_id"]').val();
        }

        if (includeProductsCheckbox.is(':checked')) {
            data.include_products = 1;
        }

        if (storeSelect.length) {
            data.store_sync_code = storeSelect.val();
        }
        return data
    }

    function displayLoadingGifInButton() {
        fetchReportButton.html('<img src="/includes/charts/gfx/ajax-loader.gif" alt="Loading..." style="margin-right: 10px;"/> Henter data...');
    }

    function removeLoadingGifFromButton() {
        fetchReportButton.html("Oppdater");
    }

    function initReportDatePickers() {
        if (typeof flatpickr === 'undefined') {
            return;
        }

        dateFromInput.add(dateToInput).each(function () {
            if (this._flatpickr) {
                return;
            }

            flatpickr(this, {
                allowInput: false,
                dateFormat: "d/m/Y",
                disableMobile: true
            });
        });
    }

    // /**
    //  *
    //  * @param {{html: string}} dataObj
    //  */
    // function updateHTML(dataObj) {
    //     $('div#' + IDENTIFIER + '-report-wrapper').html(dataObj.html)
    //     updateDateDisplay();
    //
    //     $("#" + IDENTIFIER + "-excel-export-button").click(function(e) {
    //         const data = getDataParameters();
    //         $.ajax({
    //             type: 'GET',
    //             url: excelExportURL,
    //             data: data,
    //             dataType: 'json'
    //         }).success(function (data) {
    //             if (data?.excel_file_name) {
    //                 downloadExcelFileFromReportFolder(data.excel_file_name);
    //                 return;
    //             }
    //             alert("Feil under eksportering");
    //         }).error(function () {
    //             console.log("error");
    //         });
    //     });
    // }
});
